import TagList from '@wix/da-ds/pkg/TagList';
import { useTranslation } from 'react-i18next';
import {
  BiData,
  BiContextProvidedValue,
  StatsChangeLevelClickBiEvent,
} from '@wix/da-bi/pkg/events';
import { TimePeriod, TimePeriodOption } from '../../../types/reports';
import s from './SectionHeader.scss';

interface SectionHeaderProps {
  title: string;
  description: string;
  selectedTimePeriod: TimePeriod;
  onTimePeriodChange: (timePeriod: TimePeriod) => void;
  timePeriodOptions?: TimePeriodOption[];
}

const SectionHeader = ({
  title,
  description,
  selectedTimePeriod,
  onTimePeriodChange,
  timePeriodOptions,
}: SectionHeaderProps) => {
  const { t } = useTranslation();

  const defaultTimePeriodOptions: TimePeriodOption[] = [
    {
      value: TimePeriod.ALL,
      translationKey: `studio.reports.timePeriods.${TimePeriod.ALL}`,
    },
    {
      value: TimePeriod.PAST_YEAR,
      translationKey: `studio.reports.timePeriods.${TimePeriod.PAST_YEAR}`,
    },
    {
      value: TimePeriod.PAST_MONTH,
      translationKey: `studio.reports.timePeriods.${TimePeriod.PAST_MONTH}`,
    },
  ];

  const options = timePeriodOptions || defaultTimePeriodOptions;

  return (
    <div className={s['root']}>
      <div className={s['text']}>
        <h2 className={s['title']}>{title}</h2>
        <p className={s['subtitle']}>{description}</p>
      </div>
      {options.length > 0 && (
        <div className={s['tags']}>
          <TagList
            tags={options.map(option => ({
              tagname: option.translationKey
                ? t(option.translationKey)
                : option.label || '',
              isSelected: selectedTimePeriod === option.value,
              onClick: () => onTimePeriodChange(option.value),
              biData: BiData<StatsChangeLevelClickBiEvent>({
                evid: 831,
                sectionname: BiContextProvidedValue,
                time_period: option.value,
              }),
            }))}
          />
        </div>
      )}
    </div>
  );
};

export default SectionHeader;
